import photo from "../FeaturedResources/FeaturedResourceimages/photo.png"
import photo1 from "../FeaturedResources/FeaturedResourceimages/photo1.png"
import photo2 from "../FeaturedResources/FeaturedResourceimages/photo2.png"
import photo3 from "../FeaturedResources/FeaturedResourceimages/photo3.png"
import photo4 from "../FeaturedResources/FeaturedResourceimages/photo4.png"
export const FeaturedData=[{
    image:photo,
    Description:"How to Build a Scalable Application up to 1 Million Users on AWS",
    text:"Read More"
},{
    image:photo1,
    Description:"How to Build a Scalable Application up to 1 Million Users on AWS",
    text:"Read More"
},{
    image:photo2,
    Description:"How to Build a Scalable Application up to 1 Million Users on AWS",
    text:"Read More"
},{
    image:photo3,
    Description:"How to Build a Scalable Application up to 1 Million Users on AWS",
    text:"Read More"
},{
    image:photo4,
    Description:"How to Build a Scalable Application up to 1 Million Users on AWS",
    text:"Read More"
},]